"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var React = __importStar(require("react"));
var react_query_1 = require("react-query");
var format_price_1 = __importDefault(require("../../../../utils/format-price"));
var api_1 = require("../../../returns/api");
var generate_diaper_bank_edit_url_1 = require("../../mutations/generate-diaper-bank-edit-url");
var get_diaper_funds_1 = require("../../queries/get-diaper-funds");
var DiaperFund = function (_a) {
    var _b;
    var email = _a.email;
    if (!((_b = window.accountApp.diaperFund) === null || _b === void 0 ? void 0 : _b.isEnabled))
        return null;
    if (!email)
        return null;
    var client = (0, api_1.getSublessAPIClient)();
    var _c = (0, react_query_1.useQuery)("diaperFunds", function () { return (0, api_1.getSublessAPIClient)().request(get_diaper_funds_1.GetDiaperFunds); }), data = _c.data, isLoading = _c.isLoading;
    var diaperFunds = data === null || data === void 0 ? void 0 : data.account.diaperBanks;
    var _d = (0, react_query_1.useMutation)("generateDiaperFundEditUrl", function (variables) {
        return (0, api_1.getSublessAPIClient)().request(generate_diaper_bank_edit_url_1.GENERATE_DIAPER_BANK_EDIT_URL, variables);
    }), generateDiaperFundEditUrlAsync = _d.mutateAsync, generateDiaperFundEditUrlError = _d.error;
    var generateEditUrlForDiaperFund = function (slug) { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, generateDiaperFundEditUrlAsync({ slug: slug })];
                case 1:
                    result = _a.sent();
                    if (!(result === null || result === void 0 ? void 0 : result.account_diaperBankEditUrl)) {
                        alert("There was an error! Please try again.");
                        return [2 /*return*/];
                    }
                    window.open(result.account_diaperBankEditUrl, '_blank');
                    return [2 /*return*/];
            }
        });
    }); };
    var diaperFundLandingPageUrl = window.accountApp.diaperFund.pageUrl;
    return (React.createElement("div", null,
        React.createElement("div", { className: 'padding-vertical-5 account-container padding-horizontal-3 bg-white bordered border-very-light-pink' },
            React.createElement("div", { className: ' grid-x grid-padding-x' },
                React.createElement("div", { className: 'cell small-8 text-left font-size-14 padding-left-4' },
                    React.createElement("img", { className: 'h-4 padding-right-3', src: window.accountApp.iconUrls.profile }),
                    "Diaper Registry Funds")),
            !isLoading && (React.createElement("div", { className: 'padding-vertical-3 margin-top-3' },
                !!(diaperFunds === null || diaperFunds === void 0 ? void 0 : diaperFunds.length) && (React.createElement("div", null, diaperFunds.map(function (diaperFund) { return (React.createElement("div", { key: diaperFund.slug, className: (0, classnames_1.default)('bundle-item-block', 'margin-bottom-4') },
                    React.createElement("button", { className: 'button btn small hollow margin-right-2 float-right', type: 'button', onClick: function () { return generateEditUrlForDiaperFund(diaperFund.slug); } }, "Edit"),
                    React.createElement("div", { className: 'bundle-item-block--img-qty-container' },
                        React.createElement("div", { className: (0, classnames_1.default)('bundle-item-block--image-container padding-0 border-none rounded') }, diaperFund.profileImgUrl && React.createElement("img", { src: diaperFund.profileImgUrl, alt: diaperFund.babyName, className: 'rounded' }))),
                    React.createElement("div", { className: 'bundle-item-block--title-container padding-left-3' },
                        React.createElement("div", { className: (0, classnames_1.default)('font-size-14') },
                            React.createElement("a", { href: diaperFund.publicUrl, target: '_blank' },
                                diaperFund.babyName,
                                "'s Diaper Fund")),
                        React.createElement("div", { className: 'margin-top-1 font-size-12' },
                            Number(diaperFund.balance) > 0 && (React.createElement("span", null,
                                React.createElement("b", null, "Balance:"),
                                " ",
                                (0, format_price_1.default)(diaperFund.balance))),
                            Number(diaperFund.fundsRaised) > 0 && (React.createElement("span", null,
                                "\u00A0\u00A0|\u00A0\u00A0",
                                React.createElement("b", null, "Raised:"),
                                " ",
                                (0, format_price_1.default)(diaperFund.fundsRaised))),
                            diaperFund.giftCode && (React.createElement("span", null,
                                "\u00A0\u00A0|\u00A0\u00A0",
                                React.createElement("b", null, "Code:"),
                                " ",
                                diaperFund.giftCode)))))); }))),
                !(diaperFunds === null || diaperFunds === void 0 ? void 0 : diaperFunds.length) && (React.createElement("div", { className: 'padding-horizontal-3' },
                    React.createElement("a", { className: 'button btn small margin-bottom-2', href: "https://www.fundmydiapers.com/bank/new", target: '_blank' }, "Create a Diaper Registry Fund"),
                    diaperFundLandingPageUrl && (React.createElement("div", null,
                        React.createElement("a", { className: 'text-wisteria', href: diaperFundLandingPageUrl, target: '_blank' }, "Learn more"))))))))));
};
exports.default = DiaperFund;
